<template>
  <FormGroup :error="touched && !valid">
    <div class="url-input">
      <FormInput
        ref="input"
        v-model="copy"
        size="large"
        :error="touched && !valid"
        :disabled="readOnly"
        :text-invisible="!editing"
        :placeholder="placeholder"
        @keyup.enter="$refs.input.blur()"
        @focus="select()"
        @blur="unselect()"
      />
      <span v-if="!editing" class="url-input__link">
        <i
          v-if="display.iconClass"
          class="grid-field-social-handle__icon"
          :class="display.iconClass"
          role="img"
          :aria-label="iconLabel"
        ></i>
        <a
          v-if="display.href"
          :href="display.href"
          target="_blank"
          rel="noopener noreferrer"
          >{{ display.text }}</a
        >
        <template v-else>{{ display.text }}</template>
        <i
          v-if="warning"
          v-tooltip="warning"
          class="grid-field-social-handle__warning iconoir-warning-triangle"
          role="img"
          :aria-label="warning"
        ></i>
      </span>
    </div>
    <template #error>
      <span v-show="touched && !valid">
        {{ error }}
      </span>
    </template>
  </FormGroup>
</template>

<script>
import rowEditField from '@baserow/modules/database/mixins/rowEditField'
import rowEditFieldInput from '@baserow/modules/database/mixins/rowEditFieldInput'
import {
  getPlatformConfig,
  getPlatformName,
  getSocialHandleDisplay,
} from '@baserow/modules/database/utils/socialHandle'

export default {
  name: 'RowEditFieldSocialHandle',
  mixins: [rowEditField, rowEditFieldInput],
  computed: {
    display() {
      return getSocialHandleDisplay(this.value, this.field.platform)
    },
    iconLabel() {
      return this.display.platform
        ? getPlatformName(this.display.platform)
        : this.$t('gridViewFieldSocialHandle.genericPlatform')
    },
    warning() {
      if (this.display.mismatch) {
        return this.$t('gridViewFieldSocialHandle.platformMismatch', {
          detected: getPlatformName(this.display.mismatch),
          configured: getPlatformName(this.field.platform),
        })
      }
      return this.display.unparsed
        ? this.$t('gridViewFieldSocialHandle.unrecognised')
        : null
    },
    placeholder() {
      // Shows what a bare handle turns into, so the "you can just type @nike"
      // affordance is discoverable rather than something you have to try.
      const config = getPlatformConfig(this.field.platform)
      return config === null
        ? this.$t('rowEditFieldSocialHandle.placeholderAuto')
        : `@handle or https://${config.host}/${config.pathPrefix}handle`
    },
  },
}
</script>
